import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';

const WaitingLoaderAI = ({open}) => {

  const messages = [
    'Please wait...',
    'Analysing your uploaded file...',
    'Extracting key information...',
    'Almost done...',
  ];

  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    if (!open) return;

    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % messages.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [open]);

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>Analysing Your File</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2} py={2}>
          {/* You can replace CircularProgress with an actual loading image if you have one */}
          <CircularProgress />
          {/* If you want to use image, replace above line with:
              <img src="/your-loader.gif" alt="loading" width={60} />
          */}
          {/* <Typography variant="body1" align="center">
            {messages[currentMessageIndex]}
          </Typography> */}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WaitingLoaderAI;
